/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Category_AerobicInputs */

const en_us2_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerobic`)
};

const pt_br2_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aeróbico`)
};

const es_419_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aeróbico`)
};

const pt_pt2_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aeróbico`)
};

const fr_fr2_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cardio`)
};

const de_de2_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausdauer`)
};

const it_it2_exercise_category_aerobic = /** @type {(inputs: Exercise_Category_AerobicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerobico`)
};

/**
* | output |
* | --- |
* | "Aerobic" |
*
* @param {Exercise_Category_AerobicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_category_aerobic = /** @type {((inputs?: Exercise_Category_AerobicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Category_AerobicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_category_aerobic(inputs)
	if (locale === "es-419") return es_419_exercise_category_aerobic(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_category_aerobic(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_category_aerobic(inputs)
	if (locale === "de-DE") return de_de2_exercise_category_aerobic(inputs)
	if (locale === "it-IT") return it_it2_exercise_category_aerobic(inputs)
	return en_us2_exercise_category_aerobic(inputs)
});
export { exercise_category_aerobic as "exercise.category_aerobic" }